import { service } from "@/common/axios-service";
const state = {
}

const getters={
}

const actions ={
  async GetRandomQuestion() {
    return new Promise((resolve,reject)=>{
      service.post("Student/GetRandomQuestion",{})
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
}

const mutations ={
}

export default{
    state,
    getters,
    actions,
    mutations
};